export const GET_REQUESTS = 'app/dashboard/GET_REQUESTS';
export const GET_DEALERSHIPS = 'app/dashboard/GET_DEALERSHIPS';
export const GET_DEALERSHIP = 'app/dashboard/GET_DEALERSHIP';
export const GET_SESSION_GROUPS = 'app/dashboard/GET_SESSION_GROUPS';
export const GET_SESSION_GROUP = 'app/dashboard/GET_SESSION_GROUP';
export const GET_COMPLETE_SESSIONS = 'app/dashboard/GET_COMPLETE_SESSIONS';
export const CREATE_SESSION_GROUP = 'app/dashboard/CREATE_SESSION_GROUP';
export const LAUNCH_SESSION = 'app/dashboard/LAUNCH_SESSION';
export const CLEAR_SESSION_GROUP = 'app/dashboard/CLEAR_SESSION_GROUP';
